import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper';

const setCampusSlider = () => {
  const targetSlides = document.querySelectorAll(".js-campus-slider");

  targetSlides.forEach(CampusSlider => {
    const slideLength = CampusSlider?.querySelectorAll(".swiper-slide").length;
    let slideSpace = 25
    const campusBlock = CampusSlider.closest('.campus-block')

    if (slideLength > 1) {
      var swiper = new Swiper(CampusSlider, {
        modules: [Pagination, Navigation],
        speed: 500,
        loop: true,
        slidesPerView: 1,
        spaceBetween: slideSpace,
        pagination: {
          el: campusBlock.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'bullets',
        },
        navigation: {
          nextEl: campusBlock.querySelector('.swiper-next'),
          prevEl: campusBlock.querySelector('.swiper-prev'),
        },
      });

    } else {
      CampusSlider?.classList.add('slide-none');
      const navButtons = CampusSlider.closest('.campus-block')?.querySelectorAll(".swiper-next, .swiper-prev");
      navButtons?.classList.add('slide-none');
    }

    CampusSlider?.classList.add('is-init');
  });
}

export default setCampusSlider;